
import React from 'react';
import axios2 from 'services/axios2';

import {useParams} from 'react-router-dom';
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { NuDropdown } from 'components/nubox/NuDropdown';

import { withRouterJim } from "router/withRouterJim";
import NuConfirm from "components/nubox/Box/NuConfirm";
import NuCheckbox from "components/nubox/NuCheckbox"
import NuLoading from 'components/nubox/NuLoading';

import user from 'assets/img/user.jpg';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
} from 'reactstrap';
import NuListSearch from 'components/nubox/NuListSearch';



const data = [
  //{ id_medico: 1,  nombre: 'ALEX LIZARRAGA',  especialidad: '00000023',tel:''}, 
];
const data1 = [
  { value: 1, label: "Apple" },
  { value: 2, label: "Facebook" },
];
/*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
class HabPreinsCarrera extends React.Component {  

  
  
  state = {
    isLoaging:false,
    modalInsertar: false,
    
        
    form: {
      name: 0,
    },
    dataList: data,/* lista de datos */

    carreras_arr: [],
    item_selected:{},
    
  };
  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
    this.modalRef = React.createRef();//create ref
  }
  //------------------
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de datos
    //this.setState({data:[]});
    
    this.cargar_data()  
  }
   //----------------especial, actualiza valores del form -------------------------------
   handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;              
      //------------------------------------------------

      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
      

    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //---------------------------------------------

  
  //====================================================== 
  // item tiene value, label
  cargar_data = () => {
    console.log("cargar_data")
    let id_peri = this.props.store.user.id_peri;

    let param = { 
      
    }
    console.log(param);
    this.setState({isLoaging :true })
    axios2.post( 'hab_preins_carrera_get_list', param)
    .then(res => {
        //console.log(res.data)
        this.setState({isLoaging :false })

        if(res.data.length>0){ 
            this.setState({dataList: res.data});
        }else{
            this.setState({dataList: []});
            NotificationManager.error('No existen datos');
        }

    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
        
    });

  };
  //======================================================     
  //-----------------------------------------------------------------
  //-------------- cambiamos valor en la tabla
  handleCellChangeCheck=(index, columnId, checked)=>{
    console.log(checked);

    const newData = [...this.state.dataList];
    let new_value = checked? 1:0;    
    newData[index][columnId] = new_value;
    //console.log(newData);
    //setData({  data: newData    });
    this.setState({ datalist: newData });
  }
  //------------------------------------------
  //-----------------------------------------------------------------
  editar = (item) =>{
    console.log('editar');
    console.log(item);
    let idd1 = item.id_doc_mat;

    //-----------sacamos datos del localStorage
    let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;

    this.modalRef.current.editar(idd1, id_peri, periodo);
  }
  //-----------------------------------------------------------------
  eliminar = (item) =>{
    console.log('eliminar');
    
    this.refNuConfirm.current.show({
      message: 'Esta seguro de eliminar?',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        let idd = item.id_doc_mat;
        this.modalRef.current.eliminar(idd);
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })

  }
  //-------------------------------------
  okModal =()=>{
    console.log('citaOkModal');
    this.cargar_data(this.state.item_selected);
  }
  //-------------------------------------
  closeModal =()=>{
    console.log('citaCancelModal');
  }
  //------------------------------------
  //-----------------------------------
  save =() =>{
    const user = this.props.store.user;
    //const id_paciente = this.props.store.paciente.id_paciente;
    //...this.state.form,
    let param = {
            
            id_u: user.id_u,
            t_tabla: JSON.stringify( this.state.dataList),
            };
    console.log(param);
    
    axios2.post("hab_preins_carrera_save", param)
    .then(res => {
        console.log(res.data);
        if(res.data.exito === 1){ 
            toast.success(res.data.mensaje);   
            //this.limpiar();         
        }else{
            toast.error(res.data.mensaje);
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
    
  }
  //-------------------------------------
  //-------------------------------------
  render() {
  
    return (
      <div>
      
        { 
        
          //JSON.stringify( this.state )
        }
        <div className='content'>

          {/*{/*--- -----------------------------*/}
          <div className='row'>
            <div className='col-md-12'>
              <h3> Habilitar materias para preinscripción</h3>
            </div>
          </div>

          <div className='row'>
       
            {/** */}
            <div className='col-md-8'>
              <div className='top_title2'>
                <div className='row'>
                  <div className='col-md-12'>
                    
                  
                    <div className=' pull-right'>

                    </div>
                    <h4>Carreras</h4>

                    <NuLoading text="Cargando...." show= { this.state.isLoaging }/>
                  </div>
                </div>
              </div>

              <table className='table table-striped table-hover' width='100%' align='center'>
                <thead>

                  <tr>
                    <th>Cod.Carrera.</th>
                    <th>Carrera</th>
                    <th>Habilitar Preins.</th>
                    
                    <th>Accion</th>
                  </tr>

                </thead>
                <tbody>
                  {/* className='text-left' */}
                  
                  {this.state.dataList.map((item, index) => (
                    <tr key={index}> 
                      <td>{ item.id_carre }</td>
                      <td>{ item.nombreca }</td>
                      <td>
                        { 
                          //item.preinscribir_sn
                        }
                        <NuCheckbox
                          label=""
                          name="p"
                          value={ item.preinscribir_sn }
                          onChange={(e) => this.handleCellChangeCheck(index,"preinscribir_sn", e.target.checked)} 
                        />
                      </td>
                      

                      <td>
                        <div className='btn-group'>
                          { item.docente==="" &&
                            <Button className='btn btn-warning btn-sm' title='Asignar' 
                              onClick={() => this.nuevo(item)}>
                              <i className='fa fa-pencil'></i> Asignar
                            </Button>                         
                          }
                          &nbsp;
                         
                        </div>
                      </td>
                    </tr>
                  ))}



                </tbody>

                <tfoot>
                  <tr>
                    <td colSpan={4} className='text-center'>
                      <Button className='btn btn-primary ' title='Guardar' 
                        onClick={() => this.save()}  >
                        <i className='fa fa-check '></i> Guardar
                      </Button>
                    </td>
                  </tr>
                </tfoot>
              </table> 
            </div>
            {/** */}
            
          </div>


        
          
          {/*-- */}
          <div className="row">    
            
          </div>
          {/*-- */}

          

        </div>
  
        <ToastContainer />
        <NuConfirm   ref={ this.refNuConfirm }    />
        
      </div>
      
    );
  }
}
//------------para que soporte la funcionalidad de parametros

export default withRouterJim (HabPreinsCarrera);